import axios from '@/plugins/axios'

export default {
  namespaced: true,

  state: {
    loading: false,
    labels: [],
    artists: [],
    dialog: false,
    dialog_type: '',
    page: 1,
    page_size: 10,
    order_column: 'label.name',
    order_type: 'asc',
    step: 1,
    label: {
      id: null,
      name: null
    }
  },

  mutations: {
    setLabels(state, payload) {
      state.labels = payload
    },
    setStep(state, payload) {
      state.step = payload
    },
    setSelectedLabel(state, payload) {
      state.label = payload
    },
    setPage(state, payload) {
      state.page = payload
    },
    setPageSize(state, payload) {
      state.page_size = payload
    },
    setOrdering(state, payload) {
      state.order_column = payload.column
      state.order_type = payload.type
    },
    setDialog(state, payload) {
      state.dialog = payload
    },
    setLoading(state, payload) {
      state.loading = payload
    },
    setArtists(state, payload) {
      state.artists = payload
    }
  },

  actions: {
    read({ commit, state }, filters = null) {
      commit('setLoading', true)
      axios.admin
        .get('talent-scout/label', {
          params: {
            page: state.page,
            page_size: state.page_size,
            order_column: state.order_column,
            order_type: state.order_type,
            ...filters
          }
        })
        .then(r => {
          commit('setLabels', r.data.data)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },

    readArtists({ commit }, id) {
      commit('setLoading', true)
      axios.admin
        .get('talent-scout/label/' + id + '/artist')
        .then(r => {
          commit('setArtists', r.data.data)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setArtists', [])
          commit('setLoading', false)
        })
    },

    publish({ dispatch, state }, id) {
      axios.admin.put('talent-scout/label/publish/' + id).then(() => {
        dispatch('read', {
          page: state.page,
          page_size: state.page_size
        })
      })
    },

    unpublish({ dispatch, state }, id) {
      axios.admin.put('talent-scout/label/unpublish/' + id).then(() => {
        dispatch('read', {
          page: state.page,
          page_size: state.page_size
        })
      })
    },

    update({ dispatch, state }, label) {
      axios.admin
        .put('talent-scout/label', {
          id: label.id,
          name: label.name
        })
        .then(() => {
          dispatch('read', {
            page: state.page,
            page_size: state.page_size
          })
        })
    },

    createLabel({ dispatch, state }, labelName) {
      axios.admin
        .post('talent-scout/label', {
          name: labelName
        })
        .then(() => {
          dispatch('read', {
            page: state.page,
            page_size: state.page_size
          })
          dispatch('read')
        })
    }
  }
}
